export const actionTypePrefix = '@@simpleXHR';
export const reduxKey = '@@simpleXHR';
export var SimpleXHRMethod;
(function(SimpleXHRMethod) {
    SimpleXHRMethod["GET"] = "get";
    SimpleXHRMethod["POST"] = "post";
})(SimpleXHRMethod || (SimpleXHRMethod = {}));
export var SimpleXHREndpoint;
(function(SimpleXHREndpoint) {
    SimpleXHREndpoint["GIVE_POINTS"] = "/points_modal/give";
    SimpleXHREndpoint["GIVE_POINTS_POPUP"] = "/points_modal";
    SimpleXHREndpoint["GIVE_LLAMA"] = "/give_llama";
    SimpleXHREndpoint["GIVE_BADGE"] = "/corebadge/award";
    SimpleXHREndpoint["INIT_DEVIATION"] = "/init";
})(SimpleXHREndpoint || (SimpleXHREndpoint = {}));

//# sourceMappingURL=constants.js.map